module.exports = __webpack_public_path__ + "static/media/noticias.32f1fec7.svg";